import { render } from "./OcrPageShimmer.vue?vue&type=template&id=6a9f921d"
import script from "./OcrPageShimmer.vue?vue&type=script&lang=js"
export * from "./OcrPageShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__